
import { Component, Vue } from "vue-property-decorator";
import { Settings } from "../../../core/services/configService";
import { CrudService } from "../../../core/services/crudService";
import VoucherCard from "../../../components/voucherCard/voucherCard.vue";
import { LocalStorage } from "@shared/core/localStorage";
import ScrollableBanner from "@shared/crm/components/scrollableBanner.vue";

@Component({
  components: {
    VoucherCard,
    ScrollableBanner
  },
})
export default class VouchersBanner extends Vue {
  vouchers: any[] = [];
  currentIndex: number = 0;

  async mounted() {
    let cid = null;
    let sid = LocalStorage.getWithTimeout("cc");
    if (sid != null) {
      cid = JSON.parse(sid).id;
    }
    let url =
      cid == null
        ? `${Settings.HostName}/api/publicvouchers/list-by-customer`
        : `${Settings.HostName}/api/publicvouchers/list-by-customer/${cid}`;
    let data = await new CrudService().httpGet(url);
    if (data == null || !data.ok) {
      console.error("Crash");
      return;
    }
    this.vouchers = data.model.slice(0,4);
  }
}
